import React, { useState } from 'react';
import { PlayCircle, Lock, ChevronDown, X } from 'lucide-react';
import Footer from './footer';


const CourseAccordion = () => {
  const [isOpen, setIsOpen] = useState(true);
  // Tanlangan videoni saqlash uchun state
  const [selectedVideo, setSelectedVideo] = useState(null);

  const lessons = [
    { 
      id: 1, 
      title: "Bu kurs qanday tuzilgan?", 
      duration: "00:02:30", 
      isFree: true,
      videoUrl: "https://videos.pexels.com" 
    },
    { 
      id: 2, 
      title: "AyTi o'zi nima?", 
      duration: "00:05:00", 
      isFree: true,
      videoUrl: "https://videos.pexels.com"
    },
    { 
      id: 3, 
      title: "Html,css,js", 
      duration: "00:05:00", 
      isFree: true,
      videoUrl: "https://videos.pexels.com"
    },
    { 
      id: 4, 
      title: "Backend haqida", 
      duration: "00:05:00", 
      isFree: false,
      videoUrl: "https://videos.pexels.com"
    },
    // Boshqa darslar...
  ];

  return (
    <div className="all">
    <div className="accordion-container">
      {/* Agar video tanlangan bo'lsa, pleerni ko'rsatish */}
      {selectedVideo && (
        <div className="video-player-wrapper">
          <div className="video-header">
            <h3>Hozir ko'rilmoqda: {selectedVideo.title}</h3>
            <button onClick={() => setSelectedVideo(null)} className="close-video">
              <X size={24} />
            </button>
          </div>
          <video controls autoPlay className="main-video">
            <source src={selectedVideo.url} type="video/mp4" />
            Brauzeringiz videoni qo'llab-quvvatlamaydi.
          </video>
        </div>
      )}

      <div className={`accordion-card ${isOpen ? 'active' : ''}`}>
        <div className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
          <div className="header-left">
            <span className="section-number">01</span>
            <h2 className="section-title">AyTi-ga kirish</h2>
          </div>
          <div className="header-right">
             {isOpen ? <X size={20} /> : <ChevronDown size={24} />}
          </div>
        </div>

        {isOpen && (
          <div className="accordion-content">
            {lessons.map((lesson) => (
              <div 
                key={lesson.id} 
                className={`lesson-item ${lesson.isFree ? 'clickable' : 'locked'}`}
                onClick={() => lesson.isFree && setSelectedVideo({url: lesson.videoUrl, title: lesson.title})}
              >
                <div className="lesson-left">
                  <PlayCircle size={20} className="play-icon" />
                  <span className="lesson-title">{lesson.title}</span>
                </div>
                
                <div className="lesson-right">
                  {lesson.isFree ? (
                    <span className="preview-link">Ko'rish</span>
                  ) : (
                    <>
                      <span className="duration">{lesson.duration}</span>
                      <Lock size={16} className="lock-icon" />
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
    </div>
    <Footer/>
    </div>
  );
};

export default CourseAccordion;
